const mapping = {
  requested: {
    title: 'Solicitados',
    subtitle: 'Atendimentos clínicos solicitados',
    icon: 'far fa-question-circle',
  },
  revision: {
    title: 'Em vistoria',
    subtitle: 'Atendimentos clínicos em vistoria',
    icon: 'fas fa-glasses',
  },
  correction: {
    title: 'Em correção',
    subtitle: 'Atendimentos clínicos que precisam de correção',
    icon: 'fas fa-edit',
  },
  corrected: {
    title: 'Corrigidos',
    subtitle: 'Atendimentos clínicos corrigidos pelo solicitante',
    icon: 'fas fa-edit',
  },
  screening: {
    title: 'Triagem',
    subtitle: 'Atendimentos clínicos em triagem',
    icon: 'fas fa-search',
  },
  forwarded: {
    title: 'Encaminhados',
    subtitle: 'Atendimentos clínicos encaminhados para clínicas',
    icon: 'fas fa-share',
  },
  hospitalized: {
    title: 'Internados',
    subtitle: 'Atendimentos clínicos com pets internados',
    icon: 'fas fa-procedures',
  },
  medicalRelease: {
    title: 'Alta médica',
    subtitle: 'Atendimentos clínicos com alta médica',
    icon: 'fas fa-notes-medical',
  },
  pullout: {
    title: 'Em retirada',
    subtitle: 'Atendimentos clínicos em processo de retirada',
    icon: 'fas fa-dolly-flatbed',
  },
  caught: {
    title: 'Saída',
    subtitle: 'Atendimentos clínicos com saída registrada',
    icon: 'fas fa-sign-out-alt',
  },
  done: {
    title: 'Concluídos',
    subtitle: 'Atendimentos clínicos concluídos',
    icon: 'fas fa-check',
  },
  death: {
    title: 'Falecidos',
    subtitle: 'Atendimentos clínicos com registro de falecimento',
    icon: 'fas fa-skull-crossbones',
  },
  rejected: {
    title: 'Rejeitados',
    subtitle: 'Atendimentos clínicos rejeitados',
    icon: 'fas fa-thumbs-down',
  },
  canceled: {
    title: 'Cancelados',
    subtitle: 'Atendimentos clínicos cancelados',
    icon: 'fas fa-ban',
  },
  recordAdded: {
    title: 'Prontuário atualizado',
    subtitle: 'Atendimentos clínicos com prontuário atualizado',
    icon: 'fas fa-file-medical-alt',
  },
  all: {
    title: 'Todos os atendimentos clínicos',
    icon: 'fas fa-stethoscope',
  },
}

export default (status) => mapping[status] || mapping.all
